import AdElementBase from './AdElementBase';
import Observer from '../../utils/Observer';
import AdConsts from '../../AdConsts';

export default YandexElement;

function YandexElement(url) {
  AdElementBase.apply(this, arguments);
	
  var vastData = {
    mediaFile: [ {
      url: url,
      type: ''
    } ],
    controls: [ 0 ],
  };
  var isLinear = true;
  var self = this;

  this.load = function() {
    Observer.on('ad:vendor:mediaError', onVendorMediaError);
    Observer.emit(AdConsts.ELEMENT_CREATING_SUCCESS, self);
  };
	
  function onVendorMediaError() {
    Observer.off('ad:vendor:mediaError', onVendorMediaError);
  }

  Object.defineProperties(this, {
    'vastData': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = vastData;
        if (self._vastDocument) {
          result = self._vastDocument.vastData;
        }
        return result;
      }
    },
    'linear': {
      enumerable: true,
      configurable: true,
      get: function () {
        return isLinear;
      }
    },
  });
}
YandexElement.prototype.constructor = YandexElement;
